<template>
  <at-widget-booking
    ref="widget"
    v-bind="$attrs"
    :is-admin='isAdmin ? true : false'
    :is-personal='isPersonal ? true : false'
    @ready="onReady"
  />
</template>

<script>
import { legacyWidget } from './useWidget'

export default {
  components: {
    AtWidgetBooking: legacyWidget,
  },

  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },

    isPersonal: {
      type: Boolean,
      default: false,
    },

    hiddenRideTypes: {
      type: Array,
      required: true,
    },

    selectedTab: {
      type: String,
      required: true,
    },

    user: {
      type: Object,
      required: true,
    }
  },

  watch: {
    user() {
      this.updateWidgetState()
    },
  },

  methods: {
    onReady() {
      this.updateWidgetState()

      this.$emit('ready')
    },
    updateWidgetState() {
      // on widget ready reset widget store to initial state
      // todo: inspect why we need reset widget state
      this.$refs.widget.$store.dispatch('resetInitialStore')
      this.$refs.widget.$store.commit('setLocaleLoaded', true)
      if (this.isAdmin) {
        this.$refs.widget.$store.dispatch('setAdminSelectedUser', this.user)
      }
      if (this.isPersonal) {
        this.$refs.widget.$store.dispatch('setAccount', this.user)
      }
      this.$refs.widget.$store.commit('airports/setSelectedTab', this.selectedTab)
      this.$refs.widget.$store.commit('airports/setHiddenRideTypes', this.hiddenRideTypes)
    },
  },
}
</script>
